<template>
  <article :class="['project', 'is-relative', (image && 'two') || 'one']">
    <div class="photo-container" v-if="image">
      <img
        class="project--photo"
        :src="`${basePath}${image}`"
        :title="title"
        :alt="title"
        :onerror="
          `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
        "
        :broken="image"
      />
    </div>
    <template v-if="path && path.includes('http')">
      <div class="project--info">
        <a :href="path" target="_blank" class="mock http">
          <Title
            tag="h3"
            theme="secondary"
            :underlined="abstract && true"
            bolder
            class="project--title"
            :style="`${!abstract && 'margin: 0;'}`"
          >
            <b>{{ title }}</b>
          </Title>
        </a>
        <p class="project--abstract">{{ abstract }}</p>
        <!--
      <List marked class="list--grid" style="margin-bottom: 0;">
        <li v-for="(member, index) in team" :key="index">
          {{ member }}
        </li>
      </List>
      --></div>
    </template>
    <div class="project--info" v-else-if="!path">
      <Title
        tag="h3"
        theme="secondary"
        :underlined="abstract && true"
        bolder
        class="project--title"
        :style="`${!abstract && 'margin: 0;'}`"
      >
        <b>{{ title }}</b>
      </Title>
      <p class="project--abstract">{{ abstract }}</p>
      <!--
  <List marked class="list--grid" style="margin-bottom: 0;">
    <li v-for="(member, index) in team" :key="index">
      {{ member }}
    </li>
  </List>
  -->
    </div>
    <template v-else>
      <div class="project--info">
        <router-link :to="path" class="mock">
          <Title
            tag="h3"
            theme="secondary"
            :underlined="abstract && true"
            bolder
            class="project--title"
            :style="`${!abstract && 'margin: 0;'}`"
          >
            <b>{{ title }}</b>
          </Title>
        </router-link>
        <p class="project--abstract">{{ abstract }}</p>
        <!--
      <List marked class="list--grid" style="margin-bottom: 0;">
        <li v-for="(member, index) in team" :key="index">
          {{ member }}
        </li>
      </List>
      --></div>
    </template>
  </article>
</template>
<script>
//import List from "@/components/ui/objects/List";
import Title from "@/components/ui/atoms/Title";
export default {
  components: {
    //List,
    Title
  },
  props: {
    image: {
      type: String
    },
    path: {
      type: String
    },
    title: {
      type: String,
      default: () => "No title",
      required: true
    },
    abstract: {
      type: String
    },
    team: {
      type: Array,
      default: () => []
    },
    leaders: {
      type: Array,
      default: () => []
    },
    support: {
      type: Array,
      default: () => []
    },
    management: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
$image-width: 45%;
$info-width: 55%;
.project {
  display: flex;
  overflow: hidden;
  height: 100%;
  margin-bottom: 3em;
  background-color: white;
  border: 1px solid #e1e1e1;
  flex-direction: column;
  a {
    text-decoration: none;
    color: inherit;
  }
  &.two {
    grid-template-columns: auto auto;
  }
  .photo-container {
    height: 200px;
  }
  &--photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &--info {
    padding: 1.5em;
    flex: 1 1 $info-width;
  }
  &--title:after {
    transition: all 0.3s;
  }
  &--abstract {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0;
  }
}
@media (min-width: variables.$md) {
  .project--title{
    font-size: 1.5rem;
  }
  .project {
    flex-direction: row;
    max-height: 350px;
    .photo-container {
      height: initial;
      overflow: hidden;
      flex: 1 1 $image-width;
      &:before {
        transform: skewX(4deg);
        content: "";
        background: #fff;
        width: 30px;
        position: absolute;
        margin-left: calc(#{$image-width} - 15px);
        top: 0;
        bottom: 0;
        z-index: 1;
      }
    }
    &--info {
      padding: 3em 2.5em;
      flex: 1 1 $info-width;
    }
    &--photo {
      width: 100%;
      height: 100%;
      filter: grayscale(80%);
      transition: all 1s;
    }
    &:hover {
      .project--photo {
        transform: scale(1.05) rotate(0.5deg);
        filter: grayscale(0);
      }
      .project--title:after {
        width: 80px;
      }
    }
    &:nth-child(2n) {
      .photo-container {
        order: 1;
        &:before {
          transform: skewX(-4deg);
          margin-left: -15px;
        }
      }
    }
  }
}
</style>
